// import { Activity, Home, LayoutDashboard, FileBox, Boxes, MessageSquare, ShieldAlert } from 'lucide-react';
// import { Avatar, AvatarFallback, AvatarImage } from '../../component/ui/avatar';
// import { Button } from '../../component/ui/button';
// import { Link } from 'react-router-dom';
// import { UserAgentHistory } from '../history/user-agent-history';
// import { useAgentSettingsStore } from '~/store/store';
import { Home, Boxes, FileBox, LayoutDashboard } from 'lucide-react';
import { TooltipProvider } from '../../component/ui/tooltip';
import { SideBarLinkItem } from './sidebar-link-item';
import { useSidebarStore } from '../store/sidebare-store';
import { useLocation } from 'react-router-dom';


export const Sidebar = ({ isAdmin }: { isAdmin?: boolean }) => {
  const sidebarState = useSidebarStore((s) => s.sidebarState);
  const location = useLocation();
  const currentPath = location.pathname;

  // const { agent } = useAgentSettingsStore();
  // const { pathname } = useLocation();
  // console.log('isAdmin? ', isAdmin);

  return (
    <TooltipProvider>
      {
        sidebarState.showSideBar && (
          <div className={`${isAdmin ? 'flex' : 'hidden xl:flex'} sticky top-20 h-screen w-16 md:w-[280px] lg:w-[360px] shrink-0 flex-col bg-white shadow-[2px_0px_6px_0px_rgba(0,0,0,0.15)]`}>
        {/* <div className="mx-5 mb-10 mt-5 flex items-center justify-start gap-14 text-sm">
          <Link to="/" className="font-bold text-curtin-primary-black-90">
            AIDA
          </Link>
          <span className="text-curtin-secondary-gray-02">
            {isAdmin && pathname.startsWith('/admin') ? 'ASSISTANT STUDIO' : 'STUDY ASSISTANT'}
          </span>
        </div> */}

        <div className='flex-1 overflow-auto'>
          <div className='space-y-4'>
            {/* {agent.id && (
              <div className="px-5">
                <div className="mb-10 flex items-center gap-3">
                  <Avatar className="h-[73px] w-[73px]">
                    <AvatarImage src="/images/avatar.svg" />
                    <AvatarFallback>{agent.name.charAt(0)}</AvatarFallback>
                  </Avatar>
                  <div className="space-y-1">
                    <h2 className="text-[18px] font-semibold text-curtin-secondary-black-100">{agent.name}</h2>
                  </div>
                </div>

                <Button
                  asChild
                  className="curtin-secondary-black-100 h-10 w-full border-2 border-solid border-black px-[30px] py-[15px] text-base text-white hover:bg-white hover:text-curtin-secondary-black-100"
                >
                  <Link reloadDocument to={`/assistant/${agent.id}`} className="flex items-center gap-5">
                    Start new chat <MessageSquare />
                  </Link>
                </Button>
              </div>
            )} */}

            <nav className='my-10'>
              {/* Home — hidden for students who have completed the survey */}
              {(!sidebarState.surveyResult || isAdmin) && (
                <SideBarLinkItem Icon={Home} linkText='Home' linkTo='/' toolTip='' isFocused={currentPath === '/'} />
              )}

              {/* For Researchers and Academic */}
              {/* Resource File Library */}
              {/*isAdmin && (
                <SideBarLinkItem Icon={LayoutDashboard} linkText="Resource File Library" linkTo="/resourcefile" toolTip="" />
              )*/}

              {/* Modality Management */}
              {isAdmin && (
                <SideBarLinkItem
                  isDisabled={sidebarState.modalityManagement}
                  Icon={FileBox}
                  linkText='Modality Manager'
                  linkTo='/modalities'
                  toolTip=''
                  isFocused={(currentPath.startsWith('/modalities')) ? true : false}
                />
              )}

              {/* Cluster Management */}
              {isAdmin && (
                <SideBarLinkItem
                  isDisabled={sidebarState.clusterManagement}
                  Icon={Boxes}
                  linkText='Cluster Manager'
                  linkTo='/clusters'
                  toolTip=''
                  isFocused={(currentPath.startsWith('/clusters')) ? true : false}
                />
              )}

              {/* For Students */}
              {!isAdmin && sidebarState.surveyResult && (
                <SideBarLinkItem
                  Icon={LayoutDashboard}
                  linkText='Survey Result'
                  linkTo='/student/survey/results'
                  toolTip=''
                  isFocused={currentPath === '/student/survey/results' ? true : false}
                />
              )}
            </nav>
          </div>
        </div>
      </div>
        )
      }
    </TooltipProvider>
  )
};